// extracted by mini-css-extract-plugin
export default {"headerCell":"ordersTableHead_headerCell__lRsfo","fixedCell":"ordersTableHead_fixedCell__D20j9"};